import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './languages';

// Every marketing page/section owns its own namespace (see public/locales/en)
// so a route only ever fetches the JSON it needs instead of one giant bundle.
// "common" carries nav/footer/CTA strings shared across every page.
export const NAMESPACES = [
  'common',
  'nav',
  'footer',
  'home',
  'howItWorks',
  'findCare',
  'plans',
  'quickQuote',
  'about',
  'faqs',
  'privacy',
  'terms',
  'termsOfService',
  'contact',
  'savedQuote',
  'notFound',
  'startHsa',
  'telemedicine',
  'startShield',
  'members',
  'brokers',
  'providers',
  'stories',
  'blog',
  'formsDocuments',
  'materials',
  'search',
  // One namespace per shared marketing component (components/marketing/*),
  // owned by that component alone so translating it once covers every page
  // that renders it.
  'quoteCalculator',
  'quoteModal',
  'quoteLeadForm',
  'comparisonTable',
  'savingsFlow',
  'testimonialCarousel',
  'statRow',
  'cashPriceAdvantage',
  'hsaGrowthCalculator',
  'telemedicineFeatureCard',
  'startShieldExplainer',
  'modelWorkedExamples',
  'maximizeSavingsTips',
  'priceSettingComparison',
  'preventiveCareGuide',
  'claimDemoWalkthrough',
  'brokerRegisterCta',
  'providerLeadForm',
  'stateExpansionMap',
  'stateDetailContent',
  'stateSpotlightOverlay',
  'documentList',
  'materialCard',
  'materialViewerModal',
  'startStatusAnnouncement',
  'scrollStoryHero',
  'foundationsModal',
  'providerCard',
  'providerDetailModal',
  'rxCard',
] as const;

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    ns: NAMESPACES,
    defaultNS: 'common',
    // The /:lng path segment is the source of truth once a URL is loaded
    // (see LanguageRoute); the navigator fallback below only fires for
    // legacy/unprefixed URLs before they've been redirected to one.
    detection: {
      order: ['path', 'navigator'],
      lookupFromPathIndex: 0,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
